import isMobile from '../common/is-mobile.js';
import Swiper from 'swiper';

// var topExhibitionList = new swiper ('.js-top-exhibition-list', {
//   direction: 'horizontal',
//   loop: true,
//   // slidesPerView: 5,
//   autoplay: 5e3,
//   spaceBetween: 40,
//   centeredSlides: true,
//   observer: true,
//   autoplay: {
//     delay: 4000
//   },
//   // breakpoints: {
//   //   768: {
//   //     // topExhibitionList.destroy();
//   //   }
//   // },
//   // observeParents: true,
//   preloadImages: false,
//   slidesPerView: "auto",
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 4
//   },
//   pagination: {
//     el: '.swiper-exhibition-pagination',
//     clickable: true,
//     renderBullet: function (index, className) {
//       return '<span class="' + className + '"></span>';
//     },
//   },
//
//   // Navigation arrows
//   // navigation: {
//   //   nextEl: '.swiper-button-next',
//   //   prevEl: '.swiper-button-prev',
//   // },
//
//   // And if we need scrollbar
//   scrollbar: {
//     el: '.swiper-scrollbar',
//   },
//
// });

// let slide = $(".js-top-exhibition-list .swiper-slide").length;
// if(slide < 2) {
//   // $('.c-list-residence-wrapper').addClass('is-limit');
// }



var topExhibitionList = undefined;
var winW =  window.innerWidth;
var swiperElement = $(".js-top-exhibition-list");
var swiperElementIndex = $(".js-top-exhibition-list .swiper-slide").length;
var swiperWrapper = swiperElement.find(".swiper-wrapper");
var swiperSlide = swiperElement.find(".swiper-slide");

// console.log(swiperElementIndex);
var options = {
  direction: 'horizontal',
  loop: swiperElementIndex < 2 ? false : true,
  // slidesPerView: 5,
  // autoplay: 5e3,
  spaceBetween: 40,
  centeredSlides: true,
  // observer: true,
  autoplay: {
    delay: 4000
  },
  preloadImages: false,
  slidesPerView: "auto",
  // lazy: {
  //   loadPrevNext: true,
  //   loadPrevNextAmount: 4
  // },
  breakpoints: {
    1024: {
      spaceBetween: 0
    }
  },
  pagination: {
    el: '.swiper-exhibition-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
};
function initSwiper() {
  if(swiperElement){
    var screenWidth = window.innerWidth;
    if(screenWidth > 599 && topExhibitionList == undefined) {
      topExhibitionList = new Swiper('.js-top-exhibition-list', options);
       // console.log(screenWidth);
    } else if (screenWidth < 599 && topExhibitionList != undefined) {
      // console.log("screenWidth");
      // window.removeEventListener('resize', initSwiper);
      topExhibitionList.autoplay.stop();
      topExhibitionList.detachEvents();
      topExhibitionList = undefined;
      $(".js-top-exhibition-list .swiper-slide-duplicate").remove();
      for( var i=0;i<swiperWrapper.length; i++ ) {
        swiperWrapper[i].removeAttribute('style');
      }
      for( var i=0;i<swiperSlide.length; i++ ) {
        swiperSlide[i].removeAttribute('style');
      }
    }
  }
}

if($(".js-top-exhibition-list").length) {
  initSwiper();
  $(window).on('resize', function(){
    initSwiper();
  })
}

// window.addEventListener('resize',initSwiper);
